import moment, {Moment} from 'moment/moment'

export interface FilePayload {
    IDSchueler: number
    org_FileName: string
    org_FileType: string
    org_FileSize: string
    org_FileDate: string
    org_SubFolder: string
    new_FileName: string
    uploadDate: string
}

export class File {

    IDSchueler: number
    org_FileName: string
    org_FileType: string
    org_FileSize: string
    org_FileDate: string
    org_SubFolder: string
    new_FileName: string
    uploadDate: Moment

    constructor(data: FilePayload) {
        this.IDSchueler = data.IDSchueler
        this.org_FileName = data.org_FileName
        this.org_FileType = data.org_FileType
        this.org_FileSize = data.org_FileSize
        this.org_FileDate = data.org_FileDate
        this.org_SubFolder = data.org_SubFolder
        this.new_FileName = data.new_FileName
        this.uploadDate = moment(data.uploadDate)
    }

    fill(data: FilePayload): this {
        this.IDSchueler = data.IDSchueler
        this.org_FileName = data.org_FileName
        this.org_FileType = data.org_FileType
        this.org_FileSize = data.org_FileSize
        this.org_FileDate = data.org_FileDate
        this.org_SubFolder = data.org_SubFolder
        this.new_FileName = data.new_FileName
        this.uploadDate = moment(data.uploadDate)
        return this
    }

    payload(): FilePayload {
        return {
            IDSchueler: this.IDSchueler,
            org_FileName: this.org_FileName,
            org_FileType: this.org_FileType,
            org_FileSize: this.org_FileSize,
            org_FileDate: this.org_FileDate,
            org_SubFolder: this.org_SubFolder,
            new_FileName: this.new_FileName,
            uploadDate: this.uploadDate.toISOString(),
        }
    }
}
